export var LegalEntityFormAnswerValue = /* @__PURE__ */ ((LegalEntityFormAnswerValue2) => {
  LegalEntityFormAnswerValue2["LegalEntity"] = "LegalEntity";
  LegalEntityFormAnswerValue2["OrganizationalUnitWithoutLegalForm"] = "OrganizationalUnitWithoutLegalForm";
  return LegalEntityFormAnswerValue2;
})(LegalEntityFormAnswerValue || {});
